import React, { useState } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

import Modal from 'ui_system/modals/BaseModal';
import { Theme } from 'ui_system/theme';

import { Button } from 'ui_system/token_auth/elements/Button';
import SlotHeader from './SlotHeader';

const Container = styled.div`
  padding: 40px 25px;
`;

const Title = styled.div`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 15px;
  text-align: center;
`;
const bodyPadding = css`
  padding-left: 15px;
  padding-right: 15px;
`;
const Body = styled.div`
  padding-top: 15px;
  ${bodyPadding};
`;

export const CancelButton = styled(Button)`
  width: 180px;
  margin: 0 auto;
  margin-top: 30px;

  :focus {
    outline: none;
  }
`;

const Note = styled.div`
  margin-top: 20px;
  ${bodyPadding};
  color: ${Theme.colors.lightText};

  hr {
    margin: 0px;
  }
`;

const NoteTitle = styled.div`
  margin-top: 20px;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 600;
  color: ${Theme.colors.black};
`;

const NoteField = styled.textarea`
  height: 60px;
  width: 100%;
  margin-top: 10px;
  padding: 10px;
  border: 1px solid ${Theme.colors.inputs.border};
  color: ${Theme.colors.black};
`;

const CancelSlotModal = ({
  open,
  close,
  slot,
  onCancel,
  cancelling,
  hasBookings,
  t,
}) => {
  const [guestNote, setGuestNote] = useState('');

  // Early return must come after all hooks to comply with rules-of-hooks
  if (!slot) return null;

  const renderBody = () => {
    return (
      <React.Fragment>
        <Body>
          {hasBookings
            ? t(
                'THE_CLASS_YOU_ARE_ATTEMPTING_TO_CANCEL_HAS_BOOKED_PARTICIPANTS'
              )
            : t('ARE_YOU_SURE_YOU_WANT_TO_CANCEL')}
        </Body>
        {hasBookings && (
          <Note>
            <hr />
            <NoteTitle>Note to participants</NoteTitle>
            Please include your reason for cancelling the class. This will be
            sent to participants in the cancellation email.
            <NoteField
              value={guestNote}
              onChange={(e) => setGuestNote(e.target.value)}
            />
          </Note>
        )}
      </React.Fragment>
    );
  };

  return (
    <Modal open={open} close={close}>
      <Container>
        <Title>
          {hasBookings ? t('CANCEL_BOOKED_CLASS') : t(`CANCEL_CLASS`)}
        </Title>
        <SlotHeader slot={slot} showCapacity={false} t={t} />
        {renderBody()}
        <CancelButton
          text="Submit Cancellation"
          onClick={() => onCancel(guestNote)}
          disabled={cancelling}
          faded={cancelling}
        />
      </Container>
    </Modal>
  );
};

export default CancelSlotModal;
